import EditorAdvancedView from './EditorAdvancedView'

export default EditorAdvancedView
